import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-search",
  "use": "ico-search-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"ico-search\">\n    <rect x=\"12.5\" y=\"10.2\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -5.3848 13)\" width=\"1\" height=\"5.7\" />\n    <path d=\"M13,7.5c0,3-2.5,5.5-5.5,5.5C4.5,13,2,10.5,2,7.5C2,4.5,4.5,2,7.5,2C10.5,2,13,4.5,13,7.5z M3.1,7.5\n\tc0,2.4,2,4.4,4.4,4.4s4.4-2,4.4-4.4s-2-4.4-4.4-4.4S3.1,5.1,3.1,7.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol